import { render, staticRenderFns } from "./ProjectPluginsAdd.vue?vue&type=template&id=290be5fe&scoped=true&"
import script from "./ProjectPluginsAdd.vue?vue&type=script&lang=js&"
export * from "./ProjectPluginsAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPluginsAdd.vue?vue&type=style&index=0&id=290be5fe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290be5fe",
  null
  
)

export default component.exports